module.exports = "/dist/assets/images/export.svg";